import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react'; // Import the Analytics component
import FileBrowser from './components/FileBrowser';
import './index.css';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<FileBrowser />} />
      </Routes>
      <Analytics />
    </Router>
  );
}
